import { Card, CardBody, Col } from "reactstrap";
import { PaginationSizeTitle } from "../../../../Constants/Constants";
import { DefaultPageData, PageSizeSubTitle } from "../../../../Data/BonusUi/Pagination";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DefaultPaginationList from "../Common/DefaultPaginationList";

const PaginationSize = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={PaginationSizeTitle} span={PageSizeSubTitle} />
        <CardBody>
          <DefaultPaginationList pageClass="m-b-30" pageColor="info" size="lg" data={DefaultPageData} />
          <DefaultPaginationList pageClass="m-b-30" pageColor="info" size="md" data={DefaultPageData} />
          <DefaultPaginationList pageClass="m-b-30" pageColor="info" size="sm" data={DefaultPageData} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default PaginationSize;
